import { unref, onMounted, onUnmounted, computed } from 'vue-demi'
import KeyMirror from 'keymirror'
import Vue from 'vue'

const flags = new Map()

export const EVENT_FLAG = KeyMirror({
  SYS_SIGNOUT: null,
  SYS_SWITCH_REGION_FINISHED: null,
  MODULES_SETTINGS_VENDORS_ADD_VENDOR_SUCCESS: null,
})

const eventBus = new Vue({
  methods: {
    /**
     * @param {String} event
     */
    emit (event, ...args) {
      this.$emit(event, ...args)
    },
    /**
     * @param {String} event
     * @param {Function} callback
     */
    on (event, callback) {
      if (!flags.has(event)) flags.set(event, new Set())
      /** @type {Set} */
      const idSet = flags.get(event)
      const id = Symbol(event)
      this.$on(event, (() => {
        idSet.add(id)
        // eslint-disable-next-line standard/no-callback-literal
        return (...args) => idSet.has(id) && callback(...args)
      })())
      return { cancel: () => idSet.delete(id) }
    },
    /**
     *
     * @param {String} event
     * @param {Function} callback
     */
    once (event, callback) {
      if (!flags.has(event)) flags.set(event, new Set())
      /** @type {Set} */
      const idSet = flags.get(event)
      const id = Symbol(event)
      this.$once(event, (() => {
        idSet.add(id)
        // eslint-disable-next-line standard/no-callback-literal
        return (...args) => idSet.has(id) && callback(...args)
      })())
      return { cancel: () => idSet.delete(id) }
    },
    /**
     *
     * @param {String} event
     * @param {Function} callback
     */
    off (event, callback) {
      this.$off(event, callback)
      flags.has(event) && flags.get(event).clear()
    },
  },
})

export const useEventBus = (eventName, callback, { once = false } = { }) => {
  const handleRef = computed(() => {
    if (typeof unref(callback) === 'function') {
      // eslint-disable-next-line standard/no-callback-literal
      return (...args) => unref(callback(...args))
    }
  })
  onMounted(() => {
    const handle = unref(handleRef)
    if (!handle) return
    if (!once) {
      eventBus.on(eventName, unref(handle))
    } else {
      eventBus.once(eventName, unref(handle))
    }
  })
  onUnmounted(() => {
    const handle = unref(handleRef)
    if (!handle) return
    eventBus.off(eventName, unref(handle))
  })
  return (...args) => eventBus.emit(eventName, ...args)
}

export default eventBus
